import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import KpiTargetActions from '@store/kpi/KpiTargetActions';
import KpiTargetStore from '@store/kpi/KpiTargetStore';
import {KpiOrderBy} from '@store/@types/kpi';
import {AssignmentList} from './AssignmentList';

interface AssignmentListContainerProps {
  direction: 'asc' | 'desc';
  orderBy: KpiOrderBy | undefined;
  setOrderBy: (o: KpiOrderBy) => void;
}

interface AssignmentListContainerState {}

@connectToStores
class AssignmentListContainer extends React.PureComponent<
  AssignmentListContainerProps & ReturnType<typeof AssignmentListContainer.getPropsFromStores>,
  AssignmentListContainerState
> {
  static getStores() {
    return [KpiTargetStore];
  }

  static getPropsFromStores() {
    const {completedAssignments, kpiTargetTree, assignmentsByKpiId} = KpiTargetStore.getState();
    return {completedAssignments, kpiTargetTree, assignmentsByKpiId};
  }

  componentDidMount() {
    this.refreshData().catch(console.error);
  }

  refreshData = () =>
    Promise.all([
      KpiTargetActions.fetchGoalKpiTree(),
      KpiTargetActions.allAssignments(),
      KpiTargetActions.completedAssignments(),
    ]);

  render() {
    const {
      assignmentsByKpiId,
      completedAssignments,
      kpiTargetTree,
      direction,
      orderBy,
      setOrderBy,
    } = this.props;

    return (
      <AssignmentList
        completedAssignments={completedAssignments}
        assignmentsByKpiId={assignmentsByKpiId}
        kpiTargetTree={kpiTargetTree}
        refreshData={this.refreshData}
        direction={direction}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
      />
    );
  }
}

export default AssignmentListContainer as unknown as React.FC<AssignmentListContainerProps>;
